import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
// import { Mail, Clock, FileText, Warehouse, Settings, ShieldAlert } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/Card';
import Mail from '../../assets/IconMail.svg';
import FileText from '../../assets/IconPage.svg'
import Warehouse from '../../assets/IconHome.svg'
import Settings from '../../assets/IconGear.svg'
import ShieldAlert from '../../assets/IconShield.svg'
import Clock from '../../assets/IconClock.svg'

import css from './ContactUsPage.module.css';

const ContactInfo = () => {
  const contactMethods = [
    {
      Icon: Mail,
      titleKey: 'ContactUsPage.emailSupportTitle',
      email: 'support@rennzone.com',
      descriptionKey: 'ContactUsPage.emailSupportDescription',
      subdescriptionKey: '',
    },
    {
      Icon: FileText,
      titleKey: 'ContactUsPage.privateTradeSalesTitle',
      email: 'sales@rennzone.com',
      descriptionKey: 'ContactUsPage.privateTradeSalesDescription',
      subdescriptionKey: 'ContactUsPage.privateTradeSalesSubdescription',
      hasLink: true,
      linkHref: '/p/faq',
      linkText: 'Frequently asked questions',
    },
    {
      Icon: Warehouse,
      titleKey: 'ContactUsPage.premiumStorageTitle',
      email: 'storage@rennzone.com',
      descriptionKey: 'ContactUsPage.premiumStorageDescription',
      subdescriptionKey: 'ContactUsPage.premiumStorageSubdescription',
      hasLink: true,
      linkHref: '/p/vehicle-storage',
      linkText: 'See Details',
    },
    {
      Icon: Settings,
      titleKey: 'ContactUsPage.accountsAdminTitle',
      email: 'admin@rennzone.com',
      descriptionKey: 'ContactUsPage.accountsAdminDescription',
      subdescriptionKey: '',
    },
    {
      Icon: ShieldAlert,
      titleKey: 'ContactUsPage.fraudMattersTitle',
      email: 'fraud@rennzone.com',
      descriptionKey: 'ContactUsPage.fraudMattersDescription',
      subdescriptionKey: '',
    },
    {
      Icon: Clock,
      titleKey: 'ContactUsPage.businessHoursTitle',
      email: '',
      descriptionKey: 'ContactUsPage.businessHoursDescription',
      subdescriptionKey: 'ContactUsPage.businessHoursSubdescription',
    },
  ];

  return (
    <div className={css.contactGrid}>
      {contactMethods.map((method, index) => {
        const { Icon } = method;
        return (
          <Card key={index} className={css.contactCard}>
            <CardContent className={css.contactCardContent}>
              <div className={css.contactCardInner}>
                <div className={css.contactIconWrapper}>
                  <img src={Icon} alt='icon' className={css.contactIcon} />
                </div>
                <div className={css.contactTextContent}>
                  <h3 className={css.contactMethodTitle}>
                    <FormattedMessage id={method.titleKey} />
                  </h3>
                  {method.email && (
                    <p className={css.contactEmail}>{method.email}</p>
                  )}
                  {method.descriptionKey && (
                    <p className={css.contactDescription}>
                      {method.hasLink ? (
                        <FormattedMessage
                          id={method.descriptionKey}
                          values={{
                            link: (
                              <a
                                href={method.linkHref}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={css.contactLink}
                              >
                                {method.linkText}
                              </a>
                            ),
                          }}
                        />
                      ) : (
                        <FormattedMessage id={method.descriptionKey} />
                      )}
                    </p>
                  )}
                  {method.subdescriptionKey && (
                    <p className={css.contactDescription}>
                      <FormattedMessage id={method.subdescriptionKey} />
                    </p>
                  )}
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default ContactInfo;
